export default {
    'critical_results': 'Critical results',
    'your_role_cannot_see_critical_results': 'Your role cannot see critical results.',
    'critical_values_and_findings_that_nobody_has': 'Critical values and findings that nobody has yet confirmed being told about',
    'refresh': 'Refresh',
    'laboratory': 'Laboratory',
    'radiology': 'Radiology',
    'sms_escalation_after': 'SMS escalation after',
    'no_doctor_escalation_number_or_patient_phone': 'No doctor, escalation number or patient phone could be messaged. Tell someone directly and acknowledge.',
    'not_delivered': 'Not delivered',
    'overdue': 'Overdue',
    'escalation_sent_x': 'Escalation sent {escalatedAt}',
    'escalated': 'Escalated',
    'waiting': 'Waiting',
    'no_phone_on_file': 'no phone on file',
    'no_referring_doctor': 'No referring doctor',
    'load_more': 'Load more',
    'no_critical_laboratory_result_is_waiting_to_be': 'No critical laboratory result is waiting to be acknowledged.',
    'open_for': 'Open for',
    'status': 'Status',
    'patient': 'Patient',
    'result': 'Result',
    'order': 'Order',
    'entered': '· entered',
    'referring_doctor': 'Referring doctor',
    'acknowledge': 'Acknowledge',
    'no_critical_imaging_finding_is_waiting_to_be': 'No critical imaging finding is waiting to be acknowledged.',
    'finding': 'Finding',
    'critical_finding_flagged': 'Critical finding flagged',
    'study': 'Study',
    'reported': '· reported',
    'critical_result_acknowledged': 'Critical result acknowledged',
    'x_was_told_about_x': '{told} was told about {patientName}',
    'already_acknowledged': 'Already acknowledged',
    'acknowledge_a_critical_result': 'Acknowledge a critical result',
    'cancel': 'Cancel',
    'record_acknowledgement': 'Record acknowledgement',
    'who_was_told': 'Who was told',
    'the_doctor_or_nurse_who_took_the_result_by_name': 'The doctor or nurse who took the result, by name',
    'read_back_note': 'Read-back note',
    'what_they_repeated_back_to_confirm_they_heard': 'What they repeated back to confirm they heard it correctly',
    'home_collection': 'Home collection',
    'sample_collection_visits_at_the_patients_address': 'Sample collection visits at the patient\'s address',
    'home_sample_collection_is_switched_off_for_this': 'Home sample collection is switched off for this facility. A lab manager can turn it on under Test catalogue → Lab settings.',
    'only_my_visits': 'Only my visits',
    'none_of_your_visits_match': 'None of your visits match.',
    'no_home_collection_visits_match': 'No home collection visits match.',
    'when_and_where': 'When and where',
    'note': 'Note:',
    'stat': 'STAT',
    'urgent': 'Urgent',
    'no_tests_left_on_the_order': 'No tests left on the order',
    'phlebotomist': 'Phlebotomist',
    'not_assigned': 'Not assigned',
    'attempt': 'Attempt',
    'reschedule': 'Reschedule',
    'reassign': 'Reassign',
    'assign': 'Assign',
    'mark_collected': 'Mark collected',
    'visit_failed': 'Visit failed',
    'visit_rescheduled': 'Visit rescheduled',
    'the_patient_has_been_sent_the_new_window': 'The patient has been sent the new window.',
    'the_patient_has_no_phone_on_file_so_no_sms_was': 'The patient has no phone on file, so no SMS was sent.',
    'reschedule_the_visit': 'Reschedule the visit',
    'x_order_x': '{fullName} · order {orderNumber}',
    'reschedule_and_notify_patient': 'Reschedule and notify patient',
    'the_last_attempt_failed': 'The last attempt failed:',
    'window_starts': 'Window starts',
    'window_ends': 'Window ends',
    'note_for_the_visit': 'Note for the visit',
    'added_to_the_visit_notes': 'Added to the visit notes',
    'assigned_to_x': 'Assigned to {phlebotomistName}',
    'the_patient_has_been_sent_an_sms_with_the_visit': 'The patient has been sent an SMS with the visit details.',
    'the_patient_has_no_phone_number_on_file_so_no': 'The patient has no phone number on file, so no SMS was sent.',
    'assign_a_phlebotomist': 'Assign a phlebotomist',
    'assign_and_notify_patient': 'Assign and notify patient',
    'the_patient_is_sent_an_sms_with_this_persons': 'The patient is sent an SMS with this person\'s name and the visit window.',
    'loading': 'Loading…',
    'select': 'Select…',
    'visit_marked_collected': 'Visit marked collected',
    'specimens_collected': 'Specimens collected',
    'not_now': 'Not now',
    'close': 'Close',
    'print_labels': 'Print labels',
    'print_a_label_for_each_tube_now_so_nothing': 'Print a label for each tube now so nothing travels back unlabelled.',
    'every_test_on_this_order_already_had_a_specimen': 'Every test on this order already had a specimen, so there is nothing new to label.',
    'mark_this_visit_collected': 'Mark this visit collected',
    'yes_samples_were_collected': 'Yes, samples were collected',
    'every_test_still_waiting_on_this_order_is': 'Every test still waiting on this order is booked in as collected and given an accession number. This cannot be undone from here.',
    'how_was_x_identified': 'How was {fullName} identified?',
    'asked_a_second_identifier': 'Asked a second identifier',
    'scanned_an_id_card_or_wristband': 'Scanned an ID card or wristband',
    'could_not_identify_supervisor': 'Could not identify (supervisor)',
    'why': 'Why',
    'scanned': 'Scanned',
    'visit_recorded_as_failed': 'Visit recorded as failed',
    'the_visit_did_not_happen': 'The visit did not happen',
    'record_failed_visit': 'Record failed visit',
    'what_happened': 'What happened',
    'for_example_nobody_home_patient_declined_wrong': 'For example: nobody home, patient declined, wrong address',
    'changes_to_analyser_values': 'Changes to analyser values',
    'label_reprints': 'Label reprints',
    'what_to_approve': 'What to approve',
    'reprint_approved_for_24_hours': 'Reprint approved for 24 hours',
    'reprint_refused': 'Reprint refused',
    'could_not_record_the_decision': 'Could not record the decision',
    'approved': 'Approved',
    'refused': 'Refused',
    'no_label_reprint_is_waiting': 'No label reprint is waiting.',
    'nothing_here': 'Nothing here.',
    'accession': 'Accession',
    'someone': 'Someone',
    'your_request': 'Your request',
    'approve': 'Approve',
    'refuse': 'Refuse',
    'printed': '· printed',
    'until_x': '· until {expiresAt}',
    'change_approved': 'Change approved',
    'change_refused_the_analyser_value_is_back': 'Change refused; the analyser value is back',
    'no_change_to_an_analyser_value_is_waiting': 'No change to an analyser value is waiting.',
    'test': 'Test',
    'analyser_changed_to': 'Analyser → changed to',
    'the_analyser_value_x_goes_back_on_the_result_as': 'The analyser value {analyserValue} goes back on the result as a new version.',
    'why_is_the_change_refused': 'Why is the change refused?',
    'refuse_and_restore': 'Refuse and restore',
    'add_tests_x': 'Add tests · {orderNumber}',
    'x_the_difference_is_billed_to_this_patient': '{patientName}. The difference is billed to this patient.',
    'add': 'Add',
    'item': 'item',
    'result_amended': 'Result amended',
    'amend_result_x': 'Amend result · {name}',
    'amend_result': 'Amend result',
    'the_original_value_stays_on_the_record_the': 'The original value stays on the record. The ordering doctor and the patient are told, and the corrected result goes back to be verified again before it is released.',
    'new_value': 'New value',
    'unit': 'Unit',
    'comment_on_the_result': 'Comment on the result',
    'reason_for_the_amendment': 'Reason for the amendment',
    'at_least_x_characters_shown_on_the_report_and': 'At least {MIN_REASON} characters. Shown on the report and kept in the audit trail.',
    'qc_override_reason': 'QC override reason',
    'quality_control_has_failed_for_this_test_a': 'Quality control has failed for this test. A supervisor may report anyway by giving a reason.',
    'critical_value_acknowledged': 'Critical value acknowledged',
    'x_was_told_and_read_the_value_back': '{told} was told and read the value back',
    'acknowledge_critical_value': 'Acknowledge critical value',
    'the_clinician_or_nurse_who_received_the_result': 'The clinician or nurse who received the result',
    'what_they_read_back_to_you_and_how_phone_in': 'What they read back to you, and how (phone, in person)',
    'back': 'Back',
    'at_least_x_characters_it_is_kept_in_the_audit': 'At least {minLength} characters. It is kept in the audit trail.',
    'organism_or_no_growth': 'Organism (or \'No growth\')',
    'colony_count_e_g_10_5_cfu_ml': 'Colony count, e.g. >10^5 CFU/mL',
    'antibiotic': 'Antibiotic',
    'remove_antibiotic': 'Remove antibiotic',
    'tests': 'Tests',
    'search_by_name_or_code_then_click_a_test_or': 'Search by name or code, then click a test or panel to add it',
    'e_g_cbc_haemoglobin_tsh': 'e.g. CBC, haemoglobin, TSH',
    'your_test_catalogue_is_empty': 'Your test catalogue is empty.',
    'nothing_in_the_catalogue_matches_x': 'Nothing in the catalogue matches "{value}".',
    'everything_matching_is_already_on_the_order': 'Everything matching is already on the order.',
    'add_tests_and_panels': 'Add tests and panels',
    'first': 'first.',
    'panel': 'panel',
    'remove_x': 'Remove {name}',
    'total': 'Total',
    'test_catalogue': 'Test catalogue',
    'tests_panels_reference_ranges_prices_and_the': 'Tests, panels, reference ranges, prices and the analysers that send results',
    'link_charge_items': 'Link charge items',
    'add_test': 'Add test',
    'add_panel': 'Add panel',
    'panels': 'Panels',
    'instruments': 'Instruments',
    'lab_settings': 'Lab settings',
    'search_by_name_or_code': 'Search by name or code',
    'no_test_matches': 'No test matches.',
    'no_tests_yet_add_the_tests_this_lab_performs': 'No tests yet. Add the tests this lab performs; panels such as CBC are built from them.',
    'code': 'Code',
    'department': 'Department',
    'reference': 'Reference',
    'x_bands': '{length} bands',
    'tat': 'TAT',
    'price': 'Price',
    'active': 'active',
    'retired': 'retired',
    'no_panel_matches': 'No panel matches.',
    'no_panels_yet_a_panel_is_what_a_doctor_orders': 'No panels yet. A panel is what a doctor orders by name — CBC, LFT — and expands into its tests.',
    'panel_2': 'Panel',
    'charge_items_linked': 'Charge items linked',
    'x_created_x_tariff_rows_added_x_invoice_lines': '{chargeItemsCreated} created, {tariffRowsAdded} tariff rows added, {invoiceLinesRelinked} invoice lines re-linked',
    'give_every_test_panel_and_imaging_study_a': 'Give every test, panel and imaging study a charge item so prices, tariffs and reports agree',
    'done': 'Done',
    'finished': 'Finished',
    'safe_to_run_again_anything_already_linked_is': 'Safe to run again: anything already linked is left alone, and only what is missing is created.',
    'also_fix_old_invoice_lines': 'Also fix old invoice lines',
    'sets_the_charge_item_on_lab_and_imaging_lines': 'Sets the charge item on lab and imaging lines of existing invoices that have none. It can take longer on a large history.',
    'test_updated': 'Test updated',
    'test_added': 'Test added',
    'edit_x': 'Edit {name}',
    'add_a_test': 'Add a test',
    'how_the_result_is_entered_what_is_normal_for': 'How the result is entered, what is normal for whom, and what it costs',
    'save_changes': 'Save changes',
    'analysers_send_this_code': 'Analysers send this code',
    'hb': 'HB',
    'name': 'Name',
    'haemoglobin': 'Haemoglobin',
    'specimen': 'Specimen',
    'whole_blood_edta': 'Whole blood (EDTA)',
    'container': 'Container',
    'lavender_top': 'Lavender top',
    'result_type': 'Result type',
    'g_dl': 'g/dL',
    'turnaround_minutes': 'Turnaround (minutes)',
    'choices': 'Choices',
    'comma_separated': 'Comma separated',
    'negative_positive_reactive': 'Negative, Positive, Reactive',
    'abnormal_options': 'Abnormal options',
    'choose_the_choices_above_that_make_a_result': 'Choose the choices above that make a result abnormal, such as Positive or Reactive. They flag automatically.',
    'type_the_choices_above_first': 'Type the choices above first.',
    'method': 'Method',
    'cyanmethaemoglobin': 'Cyanmethaemoglobin',
    'decimals': 'Decimals',
    'digits_after_the_point_on_the_report': 'Digits after the point on the report',
    'sort_order': 'Sort order',
    'lower_comes_first_on_sheets_and_reports': 'Lower comes first on sheets and reports',
    'quick_values': 'Quick values',
    'comma_separated_one_click_enters_the_value_on': 'Comma separated; one click enters the value on the bench',
    'negative_positive_nil_trace': 'Negative, Positive, Nil, Trace',
    'default_value': 'Default value',
    'pre_filled_on_the_sheet_until_someone_types': 'Pre-filled on the sheet until someone types',
    'negative': 'Negative',
    'loinc_code': 'LOINC code',
    'sent_with_each_released_result_on_an_nphies': 'Sent with each released result on an NPHIES claim',
    'the_international_code_insurers_use_for_this': 'The international code insurers use for this test',
    'sent_out_to_a_reference_lab': 'Sent out to a reference lab',
    'active_orderable': 'Active (orderable)',
    'reference_ranges': 'Reference ranges',
    'by_sex_and_age_the_first_matching_band_prints': 'By sex and age; the first matching band prints on the report and drives the flag.',
    'the_expected_result_e_g_negative_printed_on_the': 'The expected result, e.g. "Negative" — printed on the report next to the value.',
    'add_band': 'Add band',
    'no_reference_range_results_are_never_flagged': 'No reference range — results are never flagged.',
    'any_sex': 'Any sex',
    'male': 'Male',
    'female': 'Female',
    'from_years': 'From (years)',
    'to_years': 'To (years)',
    'low': 'Low',
    'high': 'High',
    'expected_e_g_negative': 'Expected, e.g. Negative',
    'remove_band': 'Remove band',
    'critical_low': 'Critical low',
    'at_or_below_the_ordering_doctor_is_paged': 'At or below: the ordering doctor is paged',
    'critical_high': 'Critical high',
    'at_or_above': 'At or above',
    'reportable_low': 'Reportable low',
    'optional_a_result_below_this_is_refused_at': 'Optional. A result below this is refused at entry until it is repeated or confirmed',
    'reportable_high': 'Reportable high',
    'optional_a_result_above_this_is_refused_at': 'Optional. A result above this is refused at entry until the sample is diluted and repeated',
    'panel_updated': 'Panel updated',
    'panel_added': 'Panel added',
    'add_a_panel': 'Add a panel',
    'ordered_by_one_name_resulted_test_by_test': 'Ordered by one name, resulted test by test',
    'cbc': 'CBC',
    'complete_blood_count': 'Complete blood count',
    'panel_price': 'Panel price',
    'tests_alone_x': 'Tests alone: {chosenTotal}',
    'tests_in_this_panel_x': 'Tests in this panel ({length})',
    'filter_tests': 'Filter tests',
    'ask_the_patient_their_full_name_then_check_it': 'Ask the patient their full name, then check it against {fullName} ({mrn}) before drawing.',
    'collect': 'Collect',
    'next_patient': 'Next patient',
    'how_was_the_patient_identified': 'How was the patient identified?',
    'scanned_the_wristband': 'Scanned the wristband',
    'wristband': 'Wristband',
    'scan_the_wristband_barcode': 'Scan the wristband barcode',
    'why_the_patient_could_not_be_identified': 'Why the patient could not be identified',
    'at_least_5_characters_kept_on_the_specimen': 'At least 5 characters. Kept on the specimen.',
    'could_not_update_the_instrument': 'Could not update the instrument',
    'could_not_rotate_the_key': 'Could not rotate the key',
    'each_analyser_gets_its_own_key_the_bridge': 'Each analyser gets its own key. The bridge beside the machine sends frames with it; results appear on the bench for verification like any typed result.',
    'unmatched_results': 'Unmatched results',
    'add_instrument': 'Add instrument',
    'analyser_gateway_listening_on_x_x_x_bridge_s': 'Analyser gateway listening on {hostname}:{value} — {connections} bridge(s) connected. Serial and TCP bridge agents dial in with the run.bat issued with each key.',
    'analysers_reach_this_cloud_server_only_through': 'Analysers reach this cloud server only through the HTTPS bridge (tools/analyser-bridge) with the instrument key; the TCP gateway runs on local servers only.',
    'the_analyser_gateway_is_off_on_this_server': 'The analyser gateway is off on this server (ANALYSER_GATEWAY_PORTS). Bridges can still post frames over HTTPS with the instrument key.',
    'no_analysers_connected_yet_add_one_to_get_a_key': 'No analysers connected yet. Add one to get a key for its bridge.',
    'instrument': 'Instrument',
    'key': 'Key',
    'last_seen': 'Last seen',
    'never': 'never',
    'messages': 'Messages',
    'codes_mapped': 'Codes mapped',
    'disabled': 'disabled',
    'manual_mode': 'manual mode',
    'receiving': 'receiving',
    'direct': 'direct :',
    'while_on_frames_from_this_machine_are_refused': 'While on, frames from this machine are refused and results are typed by hand',
    'resume': 'Resume',
    'manual': 'Manual',
    'issue_a_new_key': 'Issue a new key',
    'edit': 'Edit',
    'instrument_updated': 'Instrument updated',
    'add_an_analyser': 'Add an analyser',
    'the_bridge_program_beside_the_machine_will_get': 'The bridge program beside the machine will get a key for it',
    'save': 'Save',
    'add_and_show_key': 'Add and show key',
    'short_e_g_xn550': 'Short, e.g. XN550',
    'sysmex_xn_550': 'Sysmex XN-550',
    'manufacturer': 'Manufacturer',
    'protocol': 'Protocol',
    'what_the_machine_speaks_either_is_accepted_on': 'What the machine speaks; either is accepted on the wire',
    'hl7_v2_oru_r01': 'HL7 v2 (ORU^R01)',
    'astm_e1394': 'ASTM E1394',
    'image_import_agent_now_set_up_under_radiology': 'Image import agent (now set up under Radiology → Setup)',
    'how_it_connects': 'How it connects',
    'direct_the_analyser_dials_this_server_itself_no': 'Direct: the analyser dials this server itself, no bridge PC',
    'through_a_bridge_pc_key': 'Through a bridge PC (key)',
    'directly_to_this_server': 'Directly to this server',
    'port_on_this_server': 'Port on this server',
    '41500_to_41599_one_per_analyser': '41500 to 41599, one per analyser',
    'notes': 'Notes',
    'bench_2_com3_via_bridge_pc': 'Bench 2, COM3 via bridge PC',
    'active_its_key_is_accepted': 'Active — its key is accepted',
    'copied': 'Copied',
    'could_not_copy_select_and_copy_by_hand': 'Could not copy — select and copy by hand',
    'key_for_x': 'Key for {name}',
    'shown_once_put_it_in_the_bridge_beside_the': 'Shown once. Put it in the bridge beside the machine; rotate it here if it is ever lost.',
    'done_i_have_saved_it': 'Done, I have saved it',
    'copy_key': 'Copy key',
    'serial_rs_232_or_network_analyser_download_the': 'Serial (RS-232) or network analyser: download the matching run.bat, put it beside the bridge agent\'s exe on the PC the analyser is wired to, and double-click it. It dials this server\'s analyser gateway at',
    'with_the_key_baked_in': 'with the key baked in.',
    'run_bat_serial_bridge_com_port': 'run.bat — serial bridge (COM port)',
    'run_bat_tcp_relay_bridge_lan_analyser': 'run.bat — TCP relay bridge (LAN analyser)',
    'https_bridge_instead_run': 'HTTPS bridge instead: run',
    'with_this_configuration_and_point_the_analysers': 'with this configuration and point the analyser\'s host output at that PC on the port below.',
    'copy_configuration': 'Copy configuration',
    'mapping_saved': 'Mapping saved',
    'x_test_codes': '{name} — test codes',
    'what_the_analyser_calls_a_test_what_your': 'What the analyser calls a test → what your catalogue calls it. A code that already matches a catalogue code needs no row.',
    'save_mapping': 'Save mapping',
    'analyser_sends': 'Analyser sends',
    'catalogue_test': 'Catalogue test',
    'no_codes_mapped': 'No codes mapped.',
    'hgb': 'HGB',
    'remove': 'Remove',
    'add_code': 'Add code',
    'x_recent_frames': '{name} — recent frames',
    'every_frame_received_newest_first': 'Every frame received, newest first',
    'nothing_received_from_this_analyser_yet': 'Nothing received from this analyser yet.',
    'received': 'Received',
    'outcome': 'Outcome',
    'in': 'in',
    'x_rejected': ', {length} rejected',
    'format': 'Format',
    'insurance_details': 'Insurance details',
    'diagnosis': 'Diagnosis',
    'the_insurer_pays_only_for_tests_ordered_for_a': 'The insurer pays only for tests ordered for a recorded diagnosis',
    'change_the_diagnosis': 'Change the diagnosis',
    'icd_10_code_or_description': 'ICD-10 code or description',
    'no_match': 'No match.',
    'referral_number': 'Referral number',
    'optional_as_written_on_the_referral_letter': 'Optional. As written on the referral letter',
    'referring_practitioner_licence_sent_to_nphies': 'Referring practitioner licence (sent to NPHIES)',
    'referring_doctors_licence': 'Referring doctor\'s licence',
    'the_scfhs_number_of_the_doctor_who_asked_for': 'The SCFHS number of the doctor who asked for the tests',
    'optional_the_licence_or_registration_number_of': 'Optional. The licence or registration number of the doctor who asked for the tests',
    'laboratory_settings_saved': 'Laboratory settings saved',
    'could_not_save_the_settings': 'Could not save the settings',
    'home_collection_fee_saved': 'Home collection fee saved',
    'could_not_save_the_fee': 'Could not save the fee',
    'collection_and_accession': 'Collection and accession',
    'accession_numbers': 'Accession numbers',
    'tube_suffix': 'Tube suffix',
    'positive_patient_identification_at_collection': 'Positive patient identification at collection',
    'the_collector_confirms_each_patient_by': 'The collector confirms each patient by wristband scan or two identifiers before the specimen is accessioned',
    'home_sample_collection': 'Home sample collection',
    'collect_a_walk_in_specimen_only_once_its_bill': 'Collect a walk-in specimen only once its bill is paid',
    'results_and_release': 'Results and release',
    'changing_a_value_that_came_from_an_analyser': 'Changing a value that came from an analyser',
    'the_person_who_entered_a_result_cannot_verify_it': 'The person who entered a result cannot verify it',
    'hold_release_of_a_report_until_its_bill_is_paid': 'Hold release of a report until its bill is paid',
    'bill_a_panel_even_when_every_test_in_it_is': 'Bill a panel even when every test in it is already covered by another selected panel',
    'report_ready_text_message_to_the_patient': 'Report-ready text message to the patient',
    'ward_and_er_patients_are_not_texted': 'Ward and ER patients are not texted',
    'timing_and_critical_results': 'Timing and critical results',
    'stat_order_not_collected_after_minutes': 'STAT order not collected after (minutes)',
    'the_worklist_flags_a_stat_order_whose_specimen': 'The worklist flags a STAT order whose specimen is still waiting after this long',
    'qc_failure_blocks_result_entry_for_hours': 'QC failure blocks result entry for (hours)',
    'critical_result_escalation_minutes': 'Critical-result escalation (minutes)',
    'critical_result_escalation_number': 'Critical-result escalation number',
    'paged_when_no_ordering_doctor_attending_doctor': 'Paged when no ordering doctor, attending doctor or ward nurse-station phone is on file',
    '03xxxxxxxxx': '03xxxxxxxxx',
    'keep_analyser_message_logs_for_days': 'Keep analyser message logs for (days)',
    'labels_and_printed_reports': 'Labels and printed reports',
    'print_the_date_of_birth_on_labels_age_otherwise': 'Print the date of birth on labels (age otherwise)',
    'print_the_national_id_on_labels': 'Print the national ID on labels',
    'a_label_reprint_needs_a_supervisors_approval': 'A label reprint needs a supervisor\'s approval',
    'report_language': 'Report language',
    'web_address_patients_open_reports_at': 'Web address patients open reports at',
    'put_in_the_report_ready_text_message_leave': 'Put in the report-ready text message. Leave empty on a hospital server the public cannot reach; the message then says to collect the report.',
    'report_header': 'Report header',
    'blank_space_at_the_top_mm': 'Blank space at the top (mm)',
    'label_printer': 'Label printer',
    'label_width_mm': 'Label width (mm)',
    'label_height_mm': 'Label height (mm)',
    'printer_language': 'Printer language',
    'print_bridge_port': 'Print bridge port',
    'the_label_print_bridge_runs_on_each_workstation': 'The label print bridge runs on each workstation at 127.0.0.1',
    'send_a_test_label_from_this_computer': 'Send a test label from this computer',
    'home_sample_collection_fee': 'Home sample collection fee',
    'fee_for_a_home_visit_x': 'Fee for a home visit ({chargeCode})',
    'now_x': 'Now {priceMinor}',
    'save_fee': 'Save fee',
    'save_laboratory_settings': 'Save laboratory settings',
    'ref': 'Ref:',
    'stat_not_collected': 'STAT not collected',
    'due': 'due',
    'accession_numbers_allocated_label_the_tubes': 'Accession numbers allocated — label the tubes',
    'could_not_record_collection': 'Could not record collection',
    'x_x_test_s_received': '{accessionNo}: {received} test(s) received',
    'specimens_received_into_the_lab': 'Specimens received into the lab',
    'could_not_receive_specimens': 'Could not receive specimens',
    'sent_back_to_the_bench': 'Sent back to the bench',
    'results_verified': 'Results verified',
    'released_as_preliminary': 'Released as preliminary',
    'results_released': 'Results released',
    'a_different_person_must_verify_these': 'A different person must verify these',
    'this_lab_requires_results_to_be_verified_by': 'This lab requires results to be verified by someone other than the person who entered them. Ask a colleague with verification rights to sign them off.',
    'report_held_until_the_bill_is_paid': 'Report held until the bill is paid',
    'could_not_update_the_results': 'Could not update the results',
    'order_x_cancelled': 'Order {orderNumber} cancelled',
    'money_was_already_paid_the_bill_is_marked_for': 'Money was already paid - the bill is marked for refund',
    'ask_billing_to_refund_the_patient': 'Ask billing to refund the patient.',
    'could_not_print_the_collection_list': 'Could not print the collection list',
    'edit_results': 'Edit results',
    'enter_results': 'Enter results',
    'open_sheet': 'Open sheet',
    'view_sheet': 'View sheet',
    'print_report': 'Print report',
    'order_actions_for_x': 'Order actions for {orderNumber}',
    'cancel_test': 'Cancel test',
    'add_tests_to_this_order': 'Add tests to this order',
    'cancel_whole_order': 'Cancel whole order',
    'collection_bench_work_verification_and_release': 'Collection, bench work, verification and release',
    'collection_list': 'Collection list',
    'print': 'Print',
    'label_s': 'label(s)',
    'receive': 'Receive',
    'into_the_lab': 'into the lab',
    'send_out': 'Send out',
    'release_as_preliminary': 'Release as preliminary',
    'reject': 'Reject',
    'verify': 'Verify',
    'verify_and_release': 'Verify & release',
    'send_back_to_bench': 'Send back to bench',
    'release': 'Release',
    'order_tests': 'Order tests',
    'to_collect': 'To collect',
    'collected_to_receive': 'Collected · to receive',
    'on_the_bench': 'On the bench',
    'to_verify': 'To verify',
    'verified_to_release': 'Verified · to release',
    'released': 'Released',
    'approvals': 'Approvals',
    'all_departments': 'All departments',
    'where_from': 'Where from',
    'all_sources': 'All sources',
    'branch': 'Branch',
    'all_branches': 'All branches',
    'ward': 'Ward',
    'all_wards': 'All wards',
    'name_mrn_order_no_phone_cnic_or_accession': 'Name, MRN, order no., phone, CNIC or accession',
    'due_now': 'Due now',
    'only_normal_results': 'Only normal results',
    'awaiting_reference_lab': 'Awaiting reference lab',
    'scan_a_tube_to_receive_it': 'Scan a tube to receive it',
    'results_you_entered_are_greyed_out_a_colleague': 'Results you entered are greyed out: a colleague must verify them.',
    'nothing_in_this_stage': 'Nothing in this stage.',
    'select_x_tube_for_x': 'Select {specimen} tube for {fullName}',
    'tube': 'Tube',
    'priority': 'Priority',
    'unpaid': 'Unpaid',
    'awaiting_payment': 'Awaiting payment',
    'awaiting_insurer': 'Awaiting insurer',
    'no_normal_results_waiting': 'No normal results waiting.',
    'select_x': 'Select {name}',
    'sent_to': 'Sent to',
    'amended_previously': 'Amended, previously',
    'awaiting_verification': 'Awaiting verification',
    'release_with_an_unpaid_bill': 'Release with an unpaid bill',
    'the_bill_for_one_of_these_tests_is_not_fully': 'The bill for one of these tests is not fully paid. Releasing anyway needs a supervisor\'s reason.',
    'supervisor_override_reason': 'Supervisor override reason',
    'release_anyway': 'Release anyway',
    'collect_before_payment': 'Collect before payment',
    'the_bill_for_a_walk_in_test_on_this_collection': 'The bill for a walk-in test on this collection is not paid. Collecting anyway needs a supervisor\'s reason.',
    'collect_anyway': 'Collect anyway',
    'the_result_stays_on_record_the_test_goes_back': 'The result stays on record; the test goes back to the bench to be run again.',
    'why_is_it_going_back': 'Why is it going back?',
    'send_back': 'Send back',
    'sent_to_the_reference_lab': 'Sent to the reference lab',
    'the_ward_or_the_ordering_doctor_has_been_told': 'The ward or the ordering doctor has been told',
    'cancel_x': 'Cancel {name}',
    'cancel_order_x': 'Cancel order {orderNumber}',
    'x_x_only_a_test_that_has_no_result_yet_can_be': '{fullName} · {orderNumber}. Only a test that has no result yet can be cancelled; its unpaid bill line is removed.',
    'x_every_test_on_this_order_that_has_no_result': '{fullName}. Every test on this order that has no result yet is cancelled and its unpaid bill lines are removed.',
    'reason_for_cancelling': 'Reason for cancelling',
    'order_placed': 'Order placed',
    'check_the_bill': 'Check the bill',
    'could_not_place_the_order': 'Could not place the order',
    'take_the_payment_now_so_the_specimen_can_be': 'Take the payment now so the specimen can be drawn straight away.',
    'later': 'Later',
    'take_payment': 'Take payment',
    'the_bill_opens_in_a_new_tab_with_its_payment': 'The bill opens in a new tab with its payment and receipt buttons.',
    'order_lab_tests': 'Order lab tests',
    'place_order': 'Place order ·',
    'not_registered_yet_register_them_in_a_new_tab': 'Not registered yet? Register them in a new tab, then search again.',
    'new_patient': 'New patient',
    'optional_searchable_on_the_worklist': 'Optional. Searchable on the worklist',
    'referring_doctors_phone': 'Referring doctor\'s phone',
    'optional_told_when_a_result_is_critical_or': 'Optional. Told when a result is critical or amended',
    'bill_now_at_the_desk_walk_in_patient': 'Bill now at the desk (walk-in patient)',
    'bill_to': 'Bill to',
    'leave_on_self_pay_unless_an_insurer_or_panel': 'Leave on self-pay unless an insurer or panel covers this order',
    'self_pay': 'Self-pay',
    'covered_as': 'Covered as',
    'an_order_without_a_bill_is_marked_and_reported': 'An order without a bill is marked and reported',
    'credit_billed_later': 'Credit (billed later)',
    'hospital_staff': 'Hospital staff',
    'free_of_charge': 'Free of charge',
    'reason': 'Reason',
    'home_collection_a_phlebotomist_visits_the': 'Home collection (a phlebotomist visits the patient)',
    'address': 'Address',
    'visit_notes': 'Visit notes',
    'gate_code_landmark_who_to_ask_for': 'Gate code, landmark, who to ask for',
    'clinical_notes': 'Clinical notes',
    'x_the_ward_or_the_ordering_doctor_is_told_and': '{summary}. The ward or the ordering doctor is told, and the specimen goes back to be drawn again.',
    'choose_a_reason': 'Choose a reason',
    'note_2': 'Note',
    'optional_what_was_seen': 'Optional: what was seen',
    'kind': 'Kind',
    'no_critical_value_was_raised_in_this_period': 'No critical value was raised in this period.',
    'raised': 'Raised',
    'critical': 'Critical',
    'replaced': 'replaced',
    'told': 'Told',
    'recorded_no_message_log': 'recorded, no message log',
    'acknowledged': 'Acknowledged',
    'by': 'by',
    'staff': 'staff',
    'open': 'Open',
    'time_to_acknowledge': 'Time to acknowledge',
    'no_order_without_a_bill_in_this_period': 'No order without a bill in this period.',
    'ordered': 'Ordered',
    'imaging': 'Imaging',
    'not_marked': 'Not marked',
    'placed_by': 'Placed by',
    'export_this_page_csv': 'Export this page (CSV)',
    'rows_x_to_x': 'Rows {value} to {value2}',
    'previous_page': 'Previous page',
    'next_page': 'Next page',
    'lab_reports': 'Lab reports',
    'what_the_laboratory_did_for_whom_how_fast_and': 'What the laboratory did, for whom, how fast, and where money is owed back',
    'volume_and_revenue': 'Volume & revenue',
    'referring_doctors': 'Referring doctors',
    'turnaround_by_test': 'Turnaround by test',
    'rejections': 'Rejections',
    'critical_values': 'Critical values',
    'orders_without_a_bill': 'Orders without a bill',
    'cancelled_with_money_to_refund': 'Cancelled with money to refund',
    'from': 'From',
    'to': 'To',
    'up_to': 'Up to',
    'days': 'days.',
    'revenue': 'Revenue',
    'no_tests_were_ordered_in_this_period': 'No tests were ordered in this period.',
    'by_test': 'By test',
    'by_department': 'By department',
    'group_by': 'Group by',
    'no_orders_in_this_period': 'No orders in this period.',
    'orders': 'Orders',
    'no_reports_were_released_in_this_period': 'No reports were released in this period.',
    'average': 'Average',
    '90th_percentile': '90th percentile',
    'beyond_target': 'Beyond target',
    'average_minutes': 'Average minutes',
    '90th_percentile_minutes': '90th percentile minutes',
    'average_and_90th_percentile_run_from_the_order': 'Average and 90th percentile run from the order being placed to the report being released. Beyond target counts reports that took longer than the test\'s turnaround time from the moment the sample was collected.',
    'no_specimens_were_collected_or_rejected_in_this': 'No specimens were collected or rejected in this period.',
    'collected': 'Collected',
    'rejected': 'Rejected',
    'reruns': 'Reruns',
    'rejection_rate': 'Rejection rate',
    'rejection_rate_2': 'Rejection rate %',
    'why_specimens_were_rejected': 'Why specimens were rejected',
    'tests_on_these_orders_were_cancelled_after_the': 'Tests on these orders were cancelled after the patient had paid. Refund due is what the patient paid beyond what is still billed.',
    'mrn': 'MRN',
    'invoice': 'Invoice',
    'invoice_status': 'Invoice status',
    'paid': 'Paid',
    'still_billed': 'Still billed',
    'refund_due': 'Refund due',
    'cancelled_tests': 'Cancelled tests',
    'cancelled_at': 'Cancelled at',
    'export_loaded_rows_csv': 'Export loaded rows (CSV)',
    'no_cancelled_order_is_holding_money_that_needs': 'No cancelled order is holding money that needs refunding.',
    'test_2': 'test',
    'cancelled': 'cancelled ·',
    'x_the_result_is_entered_here_when_it_comes_back': '{summary}. The result is entered here when it comes back; the report says who performed it.',
    'reference_lab': 'Reference lab',
    'their_reference': 'Their reference',
    'optional': 'Optional',
    'the_label_printer_did_not_take_the_job': 'The label printer did not take the job',
    'the_labels_could_not_be_printed': 'The labels could not be printed',
    'approval_requested': 'Approval requested',
    'print_again_once_a_supervisor_approves_the': 'Print again once a supervisor approves; the approval lasts 24 hours.',
    'could_not_ask_for_approval': 'Could not ask for approval',
    'specimen_labels': 'Specimen labels',
    'x_tube_s_x_x_mm_x': '{size} tube(s) · {widthMm}×{heightMm} mm · {language}',
    'ask_a_supervisor_to_approve': 'Ask a supervisor to approve',
    'print_label_sheet': 'Print label sheet',
    'print_on_the_label_printer': 'Print on the label printer',
    'looking_for_the_label_printer_on_this_computer': 'Looking for the label printer on this computer…',
    'no_print_bridge_answered_on_this_computer_port': 'No print bridge answered on this computer (port',
    'start_the_label_print_bridge_here_or_print_the': '). Start the label print bridge here, or print the labels as a sheet on an ordinary printer.',
    'the_bridge_is_running_but_every_printer_it_sees': 'The bridge is running but every printer it sees is offline — check power and cable.',
    'print_bridge': 'Print bridge',
    'ready': 'ready',
    'a_supervisor_must_approve_reprinting_x': 'A supervisor must approve reprinting {value}.',
    'already_printed_x_say_why_they_are_printed_again': 'Already printed: {value}. Say why they are printed again.',
    'other': 'Other',
    'other_reason': 'Other reason',
    'copies_per_tube': 'Copies per tube',
    'printer': 'Printer',
    'bridge_default': 'Bridge default',
    'the_ordering_doctor_has_been_notified': 'The ordering doctor has been notified',
    'reflex_tests_added': 'Reflex tests added',
    'order_verified_and_released': 'Order verified and released',
    'order_verified': 'Order verified',
    'results_x': 'Results · {number}',
    'results': 'Results',
    'nothing_changed_yet': 'Nothing changed yet',
    'save_with_critical_values': 'Save with critical values',
    'save_results': 'Save results',
    'loading_the_order': 'Loading the order…',
    'you_entered': ': you entered',
    'this_result': 'this result',
    'these_results': 'these results',
    'so_a_colleague_must_verify': ', so a colleague must verify',
    'it': 'it',
    'them': 'them',
    'at_least_5_characters': 'At least 5 characters',
    'quality_control_has_failed': 'Quality control has failed',
    'results_for_these_tests_cannot_be_saved_here_a': 'Results for these tests cannot be saved here. A supervisor with the QC override permission must sign them off, or a passing control run must be recorded first.',
    'override_qc_failure': 'Override QC failure',
    'only_needed_when_you_save_results_for_the': 'Only needed when you save results for the failed tests. The reason is recorded against every result reported this way.',
    'reason_for_reporting_while_qc_has_failed': 'Reason for reporting while QC has failed',
    'at_least_x_characters': 'At least {MIN_QC_REASON} characters',
    'analyser_values_changed': 'Analyser values changed',
    'say_why_each_analyser_value_is_being_changed': ': say why each analyser value is being changed.',
    'no_reference_range': 'No reference range',
    'no_reference_range_applies_to_this_patient_so': ': no reference range applies to this patient, so the value cannot be judged. Choose a flag in the Flag column or add a comment saying how it was judged.',
    'the_ordering_doctor_will_be_notified_the_moment': '. The ordering doctor will be notified the moment these are saved. Confirm the specimen, then save.',
    'clinical_notes_2': 'Clinical notes:',
    'previous': 'Previous',
    'flag': 'Flag',
    'comment': 'Comment',
    'not_collected': 'not collected',
    'qc_failed': 'QC failed',
    'analyser': 'Analyser',
    'change_waiting_for_approval': 'Change waiting for approval',
    'analyser_value_restored': 'Analyser value restored',
    'analyser_sent': 'Analyser sent',
    'reason_2': 'Reason:',
    'critical_not_yet_acknowledged': 'Critical - not yet acknowledged',
    'acknowledged_by': 'Acknowledged by',
    'a_clinician': 'a clinician',
    'no_range': 'No range',
    'flag_for_x': 'Flag for {name}',
    'choose_a_flag': 'Choose a flag',
    'normal': 'Normal',
    'abnormal': 'Abnormal',
    'why_change_the_analyser_value_for_x': 'Why change the analyser value for {name}',
    'why_change_it_needs_approval': 'Why change it (needs approval)',
    'why_change_the_analyser_value': 'Why change the analyser value',
    'reason_for_amendment': 'Reason for amendment',
    'changing_a_value_that_is_already_entered': 'Changing a value that is already entered records an amendment; the original stays on the record.',
    'quality_control': 'Quality control',
    'control_lots_westgard_rules_and_levey_jennings': 'Control lots, Westgard rules and Levey-Jennings charts',
    'all_tests': 'All tests',
    'add_lot': 'Add lot',
    'record_a_run': 'Record a run',
    'no_control_lots_configured': 'No control lots configured.',
    'level': 'Level',
    'lot': 'Lot',
    'target_mean': 'Target mean',
    'sd': 'SD',
    'expires': 'Expires',
    'charted': 'charted',
    'could_not_check_which_tests_are_closed_for': 'Could not check which tests are closed for result entry:',
    'level_lot': 'level · lot',
    'failed_runs_from_the_last': 'Failed runs from the last',
    'hours_count_record_a_passing_control_run_for': 'hours count. Record a passing control run for each failed level to reopen the test.',
    'lot_2': '· lot',
    'target': 'Target',
    'runs': 'Runs',
    'observed_mean': 'Observed mean',
    'cv': 'CV',
    'sd_2': 'SD):',
    'in_control': 'In control',
    'x_x_sd': '{value}{zScore} SD',
    'out_of_control_do_not_report_this_run': 'Out of control — do not report this run',
    'record_a_control_run': 'Record a control run',
    'x_x_lot_x': '{name} · {level} · lot {lotNo}',
    'record': 'Record',
    'sd_from_the_target_mean': 'SD from the target mean',
    'cobas_e411': 'Cobas e411',
    'run_time': 'Run time',
    'leave_empty_for_now_a_run_cannot_be_in_the': 'Leave empty for now. A run cannot be in the future or more than 31 days old.',
    'this_lot_expired_on': 'This lot expired on',
    'a_run_against_it_will_be_refused': '; a run against it will be refused.',
    'control_lot_added': 'Control lot added',
    'add_a_control_lot': 'Add a control lot',
    'the_target_mean_and_sd_come_from_the': 'The target mean and SD come from the manufacturer\'s insert or your own peer data',
    'lot_number': 'Lot number',
    'target_sd': 'Target SD',
    'must_be_greater_than_zero': 'Must be greater than zero',
    'could_not_save_the_reason': 'Could not save the reason',
    'specimen_rejection_reasons': 'Specimen rejection reasons',
    'code_2': 'CODE',
    'reason_code': 'Reason code',
    'what_the_bench_sees': 'What the bench sees',
    'reason_label': 'Reason label',
    'could_not_re_check_the_parked_results': 'Could not re-check the parked results',
    'unmatched_analyser_results': 'Unmatched analyser results',
    'frames_whose_accession_or_test_code_matched': 'Frames whose accession or test code matched nothing. Match each to its specimen, or discard it with a reason.',
    're_match_parked_results': 'Re-match parked results',
    'tries_again_the_results_whose_specimen_was_not': 'Tries again the results whose specimen was not collected, or whose accession or code was unknown. Patient mismatches and QC failures stay for a verifier.',
    'nothing_is_waiting_every_analyser_result_found': 'Nothing is waiting. Every analyser result found its specimen.',
    'value': 'Value',
    'verifier': 'Verifier',
    'resolve': 'Resolve',
    'result_matched_and_entered_on_the_bench': 'Result matched and entered on the bench',
    'result_discarded': 'Result discarded',
    'discard': 'Discard',
    'match_to_this_specimen': 'Match to this specimen',
    'accession_number': 'Accession number',
    'type_or_scan_the_tubes_accession_to_find_the': 'Type or scan the tube\'s accession to find the specimen',
    'e_g_acc_2026_000123': 'e.g. ACC-2026-000123',
    'specimen_and_test': 'Specimen and test',
    'no_collected_specimen_carries_that_accession': 'No collected specimen carries that accession',
    'pick_the_test_this_value_belongs_to': 'Pick the test this value belongs to',
    'remember': 'Remember:',
    'sends': 'sends',
    'for_this_test': 'for this test',
    'the_analyser_refused_this_value_for_a_safety': 'The analyser refused this value for a safety reason. Attach it only after checking the specimen, and say why it is safe.',
    'required_why_this_value_is_safe_to_attach': 'Required: why this value is safe to attach',
    'required_to_discard_optional_when_matching': 'Required to discard; optional when matching',
    'why_this_is_being_matched_or_thrown_away': 'Why this is being matched or thrown away',
    'compatible': 'Compatible',
    'incompatible': 'Incompatible',
    'cancel_request_and_release_unit': 'Cancel request',
    'issue_unit': 'Issue',
    'record_transfusion': 'Record transfusion',
    'bb_title': 'Blood bank',
    'bb_description': 'Donors, stock, cross-match and transfusion',
    'bb_request_cross_match': 'Request a cross-match',
    'bb_register_donor': 'Register donor',
    'bb_tab_stock': 'Stock',
    'bb_tab_cross_match': 'Cross-match',
    'bb_tab_donors': 'Donors',
    'bb_units_available': 'Units available',
    'bb_reserved': 'Reserved',
    'bb_expiring_within_a_week': 'Expiring within a week',
    'bb_x_reserved': '{count} reserved',
    'bb_x_expiring': '{count} expiring',
    'bb_no_units_in_stock': 'No units in stock.',
    'bb_all_units': 'All units',
    'bb_no_units_match': 'No units match.',
    'bb_group': 'Group',
    'bb_component': 'Component',
    'bb_donor': 'Donor',
    'bb_screened': 'Screened',
    'bb_screen_clear': 'clear',
    'bb_screen_pending': 'pending',
    'bb_component_whole_blood': 'Whole blood',
    'bb_component_prbc': 'Packed red cells',
    'bb_component_ffp': 'Fresh frozen plasma',
    'bb_component_platelets': 'Platelets',
    'bb_component_cryoprecipitate': 'Cryoprecipitate',
    'bb_updated': 'Updated',
    'bb_could_not_update_the_cross_match': 'Could not update the cross-match',
    'bb_no_cross_matches_requested': 'No cross-matches requested.',
    'bb_requested': 'Requested',
    'bb_reaction': 'Reaction',
    'bb_reaction_recorded': 'recorded',
    'bb_unit_collected': 'Unit collected',
    'bb_unit_collected_hint': 'It stays quarantined until the screen is clear',
    'bb_could_not_collect': 'Could not collect',
    'bb_donor_search_placeholder': 'Name, donor number or phone',
    'bb_no_donors_registered': 'No donors registered.',
    'bb_donor_no': 'No.',
    'bb_phone': 'Phone',
    'bb_last_donated': 'Last donated',
    'bb_eligible': 'Eligible',
    'bb_eligible_yes': 'yes',
    'bb_eligible_retired': 'retired',
    'bb_collect': 'Collect',
    'bb_collect_from_x': 'Collect from {name}',
    'bb_shelf_life_hint': 'Shelf life is set from the component',
    'bb_screen_released': 'Screen clear — unit released to stock',
    'bb_screen_discarded': 'Reactive screen — unit discarded',
    'bb_donor_retired': 'The donor has been retired',
    'bb_could_not_record_the_screen': 'Could not record the screen',
    'bb_infection_screen_x': 'Infection screen — {unit}',
    'bb_screen_description': 'Record every marker as negative or reactive. Nothing is assumed.',
    'bb_record_screen': 'Record screen',
    'bb_marker_hiv': 'HIV',
    'bb_marker_hepatitis_b': 'Hepatitis B',
    'bb_marker_hepatitis_c': 'Hepatitis C',
    'bb_marker_syphilis': 'Syphilis',
    'bb_marker_malaria': 'Malaria',
    'bb_negative': 'Negative',
    'bb_reactive': 'Reactive',
    'bb_answer_every_marker': '{count, plural, one {# marker still needs an answer} other {# markers still need an answer}}',
    'bb_reactive_warning': 'Any reactive marker discards the unit and retires the donor permanently.',
    'identifier_mrn': 'MR number',
    'identifier_national_id': 'national ID',
    'identifier_dob': 'date of birth',
    'identifier_father_or_husband_name': 'father\'s or husband\'s name',
    'identifier_second': 'second identifier',
    'identifier_x_or_x': '{list} or {last}',
    'the_patients_x': 'The patient\'s {identifier}',
};
//# sourceMappingURL=lab.js.map